// Selectors
import { useSelector } from 'react-redux'

// Types
import { ApiRequest, State } from 'types'
import { ApiRequestDefaultValues } from 'modules/requests/models'

export const useRequest = (actionType: string, key?: string | number): ApiRequest => {
  const action = useSelector<
    State,
    {
      default: ApiRequest

      [key: string]: ApiRequest
    }
  >(state => state.requests[actionType])
  const request = action && action[key ? String(key) : 'default']
  return request || ApiRequestDefaultValues
}
